import { SectionHeading } from "@/components/SectionHeading";
import { Container } from "@/components/Container";
import { ContactForm } from "@/components/contact/ContactForm";
import { ContactInfo } from "@/components/contact/ContactInfo";
import { STORE } from "@/constants/testIds";

export default function Contact() {
  return (
    <div data-testid={STORE.contactPage} className="bg-[var(--ibp-offwhite)]">
      <section className="bg-[var(--ibp-navy-950)] py-12 text-white sm:py-16">
        <Container>
          <SectionHeading
            tone="navy"
            kicker="Contact"
            title="Get in touch"
            subtitle="Questions about the online study platform, your purchase, or a refund review? Send us a note."
          />
        </Container>
      </section>

      <section className="py-14 sm:py-20">
        <Container>
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr,340px]">
            <ContactForm />
            <ContactInfo />
          </div>
        </Container>
      </section>
    </div>
  );
}
